"use client";

import { getPublicUrl } from "@/lib/utils";
import dynamic from "next/dynamic";

const DotLottieWorkerReact = dynamic(
	() =>
		import("@lottiefiles/dotlottie-react").then(
			(mod) => mod.DotLottieWorkerReact,
		),
	{ ssr: false },
);

export const LaurelAnimation = ({
	width,
	height,
}: { width?: number; height?: number }) => {
	return (
		<div className="relative">
			<DotLottieWorkerReact
				src={getPublicUrl("/lottie/laurel-wreath.json")}
				loop
				autoplay
				className="self-center align-center"
				width={width || 200}
				height={height || 200}
				workerId="laurel-animation-worker"
				onError={(error) => console.error("Animation error:", error)}
			/>
		</div>
	);
};
